<template>
    <div>
        <span
            v-for="p, index in CPosition"
            :key="p">
            <span class="font-bold">
                {{ p.nodeTypeName }}
            </span> - {{ p.nodeLocationName }}
            <span v-if="index !== (CPosition.length - 1)">
                ->
            </span>
        </span>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const CPosition = computed(() => {
  return params?.value?.data?.journey
  // const {  } = params?.value?.data
  // return positions.filter((item: any) => {
  //   if (item.nodeTypeName === 'Kho') {
  //     return true
  //   }

  //   return false
  // })
})

</script>

<style scoped></style>
